<!-- Start Coming Soon Area -->
<div class="coming-soon-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="coming-soon-content">
                <a routerLink="/" class="logo">
                    <img src="assets/img/black-logo.png" alt="image">
                </a>

                <h2>{{verifyEmail}}</h2>

                <div style="margin-top:20px">
                    <p>{{verifyEmailText}}</p>
                </div>

                <a class="app-btn" href="javascript:;" (click)="onLogout()">{{logout}}</a>
            </div>
        </div>
    </div>
</div>
<!-- End Coming Soon Area -->